var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.freeSpace)?_c('td',{staticStyle:{"background-color":"#f8f8f8","border":"none","padding":"5px"}}):_c('td',{staticClass:"table-cell md:table-cell",class:`${_vm.breakpoint} ${_vm.noBorderBottom ? 'no-border-bottom' : ''} ${
            _vm.allBorders ? 'all-borders' : ''
        }`},[_c('div',{staticClass:"table-data"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }